module.exports = __webpack_public_path__ + "img/20190525110031QQ截图20190524163222.efbf2eb4.png";